module.exports = __webpack_public_path__ + "static/media/lime.2a541a04.jpg";